// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_16PVvGlg9n2dPoagBUIAfL","row":"dyc95rBEgdmC_hImP2vY7","box":"_2Ciy2gpg-QuUNTd47C06af","credit":"bIdLD395wX9aqjwuDvrrz"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/MissionStatement/styles.scss
 ** module id = 480
 ** module chunks = 0
 **/